import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { graphRequest } from "./MsalConfig";
import { useAccessToken } from "./useAccessToken";

export const useProfilePhoto = () => {
  const [photo, setPhoto] = useState<string | undefined>(undefined);
  const getToken = useAccessToken();
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  useEffect(() => {
    if (!isAuthenticated || inProgress !== InteractionStatus.None) {
      return;
    }

    let isMounted = true;
    let photoUrl: string | undefined;

    const fetchPhoto = async () => {
      try {
        const token = await getToken(graphRequest.scopes);
        if (!token || !isMounted) return;

        const response = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok && isMounted) {
          const blob = await response.blob();
          photoUrl = URL.createObjectURL(blob);
          setPhoto(photoUrl);
        }
      } catch (e) {
        console.warn("Failed to fetch profile photo", e);
      }
    };

    fetchPhoto();

    return () => {
      isMounted = false;
      if (photoUrl) {
        URL.revokeObjectURL(photoUrl);
      }
    };
  }, [getToken, inProgress, isAuthenticated]);

  return photo;
};
